import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  CreditFormBox,
  FormControlsBox,
  PlanOwnerBox,
  TextsContainer,
  TitleTag,
  UseCreditBox
} from "./style";
import { withRouter } from "react-router-dom";
import Button from "../../../../../components/button";
import { PremiumAction } from "../../../../../actions";
import { PromoCode } from "./components/promoCode";
import { FormTexts } from "./components/formTexts";
import { Wallet } from "./components/wallet";
import FormMessage from "./components/formMessage";
import { Terms } from "./components/terms";
import { isEmpty } from "lodash";
import { BoxLoading } from "../../../../../components/loading";
import ErrorHandle from "../../../../../components/error/mainError";
import { getUserNameWithMobile } from "../../../../../assets/getUserIdentification";

const Index = props => {
  const [promoCode, setPromoCode] = useState("");
  const [promoButtonHandler, setPromoButtonHandler] = useState("");
  const {
    walletAmount,
    loading,
    error,
    payLoading,
    userPlanData,
    calculatePriceData,
    useWalletLoading,
    usePromoCodeLoading,
    calculatePrice,
    store,
    goToChoosePlanStep,
    fetchNecessaryRequest,
    showPlanOwnerBox,
    owner
  } = props;

  useEffect(() => {
    if (isEmpty(calculatePriceData)) {
      fetchNecessaryRequest();
    }
  }, []);
  useEffect(() => {
    const promoCodeIsValid = !!calculatePriceData.promo_code_id;
    const promoCodeButtonType = promoCodeIsValid ? "reset" : "submit";
    setPromoButtonHandler(promoCodeButtonType);
  }, [calculatePriceData.promo_code_id]);

  const usingWalletHandler = use_wallet => {
    const data = {
      ...userPlanData,
      promo_code: promoCode,
      use_wallet
    };
    calculatePrice(data, true);
  };
  const changePromoCodeHandler = promoCode => {
    setPromoCode(promoCode);
    setPromoButtonHandler("submit");
  };
  const registerPromoCode = () => {
    const data = {
      ...userPlanData,
      promo_code: promoCode,
      use_wallet: calculatePriceData.wallet_amount > 0
    };
    calculatePrice(data, false, true);
  };
  const unregisterPromoCode = () => {
    const data = {
      ...userPlanData,
      promo_code: "",
      use_wallet: calculatePriceData.wallet_amount > 0
    };
    setPromoCode("");
    setPromoButtonHandler("submit");
    calculatePrice(data, false, true);
  };
  const submit = () => {
    const data = {
      ...userPlanData,
      promo_code: promoButtonHandler === "reset" ? promoCode : "",
      use_wallet: calculatePriceData.wallet_amount > 0
    };
    store(data);
  };
  return (
    <React.Fragment>
      {!loading && !error && !isEmpty(calculatePriceData) && (
        <React.Fragment>
          <TitleTag>نسخه حرفه‌ای تنخواه‌گردان</TitleTag>
          {showPlanOwnerBox && (
            <PlanOwnerBox>
              خرید طرح برای حساب کاربری {getUserNameWithMobile(owner)}
            </PlanOwnerBox>
          )}
          <TextsContainer>
            {userPlanData && (
              <FormTexts
                userPlanData={userPlanData}
                calculatePriceData={calculatePriceData}
              />
            )}
            {((calculatePriceData.payable_amount > 0 && walletAmount > 0) ||
              calculatePriceData.wallet_amount > 0) && (
              <UseCreditBox>
                <Wallet
                  wallet_amount={walletAmount}
                  status={calculatePriceData.wallet_amount > 0}
                  onChange={data => usingWalletHandler(data)}
                  useWalletLoading={useWalletLoading}
                />
              </UseCreditBox>
            )}
            {(calculatePriceData.payable_amount > 0 ||
              calculatePriceData.promo_code_id) && (
              <CreditFormBox>
                <PromoCode
                  promoCode={promoCode}
                  onChange={promoCode => changePromoCodeHandler(promoCode)}
                  disabledInput={!!calculatePriceData.promo_code_id}
                  registerPromoCode={registerPromoCode}
                  unregisterPromoCode={() => unregisterPromoCode()}
                  promoButtonHandler={promoButtonHandler}
                  calculatePriceLoading={usePromoCodeLoading}
                  calculatePriceData={calculatePriceData}
                />
              </CreditFormBox>
            )}
          </TextsContainer>
          <FormMessage />
          <FormControlsBox>
            <Terms />
            <Button btn="primary" onClick={submit} loading={payLoading}>
              تایید و پرداخت نهایی
            </Button>
            <Button
              btn="outline"
              borderless
              onClick={() => goToChoosePlanStep()}
              disabled={payLoading}
            >
              تغییر نوع طرح و شخصی سازی
            </Button>
          </FormControlsBox>
        </React.Fragment>
      )}
      {loading && <BoxLoading />}
      <ErrorHandle message={error} request={fetchNecessaryRequest} />
    </React.Fragment>
  );
};

const mapStateToProps = store => {
  return {
    payLoading: store.Premium.payLoading,
    owner: store.Premium.owner,
    calculatePriceData: store.Premium.calculatePrice,
    loading: store.Premium.calculatePriceLoading,
    error: store.Premium.calculatePriceError,
    useWalletLoading: store.Premium.useWalletLoading,
    usePromoCodeLoading: store.Premium.usePromoCodeLoading
  };
};
const mapDispatchToProps = dispatch => {
  return {
    store: data => {
      dispatch(PremiumAction.payStore(data));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Index)
);
